import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { CustomizableValidator } from '../../../../../../../ui/gzForm/validators/customizable.validator';
import { MAX_LENGTH, validateEntityByType } from '../utils/validators';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzDropdownWebComponent } from '../../../../../../../ui/gzDropdown';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC_EXCLUSION_ITEM } from '../../../../../../../webcomponents.constants';
import { ContentControlTrafficExclusionType } from '@nirvana/shared/dtos/types/policies/common';
import { MaxLengthValidator } from '../../../../../../../ui/gzForm/validators/max-length.validator';
import { getExclusionItemTypeFormOptions } from '../../../../utils/uiSettings/contentControl/content-control.values';

@customElement(WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC_EXCLUSION_ITEM)
export class GzContentControlTrafficExclusionItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#excludedItemType')
  excludedItemType: GzFormFieldWebComponent<GzDropdownWebComponent>;

  @query('#excludedItemEntity')
  excludedItemEntity: GzFormFieldWebComponent<GzInputWebComponent, string>;

  @query('#excludedItemRemarks')
  excludedItemRemarks: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.excludedItemEntity.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field">
        <gz-form-field id="excludedItemType">
          <gz-dropdown
            @selectionChanged="${this.handleTypeFieldChange}"
            gz-form-input
            label="${translateFn('Exclusion type')}"
            options="${JSON.stringify(getExclusionItemTypeFormOptions())}"
          ></gz-dropdown>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field w-full">
        <gz-form-field id="excludedItemEntity">
          <gz-input
            gz-form-input
            label="${translateFn('Excluded item')}"
            placeholder="${translateFn('Type here')}"
          ></gz-input>
        </gz-form-field>
      </div>
      <div class="policy-grid-item-form--field w-full">
        <gz-form-field id="excludedItemRemarks">
          <gz-input
            gz-form-input
            label="${translateFn('Description')}"
            placeholder="${translateFn('Enter a description')}"
          ></gz-input>
        </gz-form-field>
      </div>
    `;
  }

  createFormGroup(): void {
    this.excludedItemType.Validators = [RequiredValidator('')];
    this.excludedItemEntity.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator((value: string) =>
        validateEntityByType(this.excludedItemType.value as ContentControlTrafficExclusionType, value)
      ),
      MaxLengthValidator(
        MAX_LENGTH,
        translateFn('The excluded item must have a maximum of {maxLength} characters.', { maxLength: MAX_LENGTH })
      ),
    ];
    this.excludedItemRemarks.Validators = [
      MaxLengthValidator(
        MAX_LENGTH,
        translateFn('The description must have a maximum of {maxLength} characters.', { maxLength: MAX_LENGTH })
      ),
    ];

    this.formGroup = new FormGroup({
      type: this.excludedItemType,
      entity: this.excludedItemEntity,
      remarks: this.excludedItemRemarks,
    });
  }

  private handleTypeFieldChange() {
    this.excludedItemEntity.validate();

    switch (this.excludedItemType.value) {
      case ContentControlTrafficExclusionType.IP:
        this.excludedItemEntity.Input.placeholder = translateFn('Enter IP or IP/mask');
        break;
      case ContentControlTrafficExclusionType.URL:
        this.excludedItemEntity.Input.placeholder = translateFn('Enter the URL');
        break;
      case ContentControlTrafficExclusionType.APPLICATION:
        this.excludedItemEntity.Input.placeholder = translateFn('Enter the application path');
        break;
    }
  }

  resetForm(resetType = true): void {
    if (resetType) {
      this.excludedItemType.value = '';
      this.excludedItemType.resetField();
    }

    this.excludedItemEntity.value = '';
    this.excludedItemEntity.resetField();

    this.excludedItemRemarks.value = '';
    this.excludedItemRemarks.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm(false);
  }
}
